<a [routerLink]="[url]" [queryParams]="queryParams" class="card widget-1" *ngIf="data">
  <div class="card-body">
   <span class="help-icon fas fa-info-circle"
     [ngbTooltip]="tooltip.text | translate"
     [placement]="tooltip.placement"
     container="body">
   </span>

    <div class="widget-content">
      <div class="widget-round {{data?.font}}">
        <div class="bg-round">
          <svg class="svg-fill">
            <use attr.xlink:href="assets/svg/icon-sprite.svg#{{data?.icon}}"></use>
          </svg>
          <svg class="half-circle svg-fill">
            <use href="assets/svg/icon-sprite.svg#halfcircle"></use>
          </svg>
        </div>
      </div>
      <div>
        <h4>{{data?.counter}}</h4>
        <span class="f-light">{{data?.name | translate}}</span>
      </div>
    </div>
    <!-- <div *ngIf="data?.pr !== 'N/A' && data?.pr !== null && data?.pr !== undefined" class="font-{{data?.font}} f-w-500">
     <i class="icon-arrow-{{ data?.pr > 0 ? 'up' : 'down' }} icon-rotate me-1"></i>
     <span>
       {{ data?.pr }}%
     </span>
   </div> -->
  </div>
</a>
